import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let dataParams = useDataValue({
    viewPath: props.viewPath,
    context: 'flow_shortcuts',
  })

  return {
    variables: {
      division_id: parseInt(dataParams?.division),
      configuration_id: dataParams?.id,
    },
    pause: !dataParams.division && !dataParams.id,
  }
}
